import React from "react";
import { useGlobalState } from "../../../Providers/GlobalStateProvider";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import SimpleRenovate from "../../../assets/img/SimpleRenovate.svg";
import DownloadourMobileApp from "../../../assets/img/iphone id.svg";
import Instagram from "../../../assets/img/Instagram.svg";
import Facebook2 from "../../../assets/img/Facebook2.svg";
import Linkedin from "../../../assets/img/Linkedin.svg";
import Twitter from "../../../assets/img/Twitter.svg";
import Youtube from "../../../assets/img/Youtube.svg";
import androidIcon from "../../../assets/img/android icon.svg";


const ProfessionalFooter = () => {
  const { globalLoading } = useGlobalState();
  if (globalLoading) return null;
  const handleViewDetails = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <div className="professional-footer-sticky">
        <div className="footer-line"></div>
        <div className="main">
          <div className="hero-width footer custom_container">
            <Row className="footer-width text-md-start mt-3 mt-sm-4 mt-md-5">
              <Col
                lg={3}
                md={4}
                sm={6}
                col={6}
                className="mt-3 mt-2 col_sm_padding"
              >
                <h5 className="footer-text-head fw-bold">For Professionals</h5>
                <ul className="list-unstyled  mt-2 mt-sm-4">
                  <li>
                    <Link
                      className="footer-text"
                      to="/professional/jobs"
                      // onClick={() => handleViewDetails()}
                    >
                      Find jobs
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="footer-text"
                      to="/professional-faq"
                      onClick={() => handleViewDetails()}
                    >
                      Professional FAQs
                    </Link>
                  </li>
                </ul>
              </Col>

              <Col
                lg={3}
                md={4}
                sm={6}
                col={6}
                className="mt-2 mt-md-2 mt-sm-4 col_sm_padding"
              >
                <h5 className="footer-text-head fw-bold">Company</h5>
                <ul className="list-unstyled mt-2 mt-sm-4">
                  <li>
                    <Link
                      className="footer-text"
                      to="/about-us"
                      onClick={() => handleViewDetails()}
                    >
                      About SimpleRenovate
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="footer-text"
                      to="/how-it-works"
                      onClick={() => handleViewDetails()}
                    >
                      How SimpleRenovate works
                    </Link>
                  </li>
                  <li>
                    <Link className="footer-text" to="/how-it-works">
                      How we vet professionals
                    </Link>
                  </li>
                  {/* <li>
                    <Link
                      className="footer-text"
                      to="/service/:serviceName"
                      onClick={() => handleViewDetails()}
                    >
                      Services
                    </Link>
                  </li> */}
                  <li>
                    <Link
                      className="footer-text"
                      to="/blogs"
                      onClick={() => handleViewDetails()}
                    >
                      Blog
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="footer-text"
                      to="/contacts-us"
                      onClick={() => handleViewDetails()}
                    >
                      Contact us
                    </Link>
                  </li>
                </ul>
              </Col>

              <Col
                lg={3}
                md={4}
                sm={6}
                col={6}
                className="mt-2 mt-md-2 mt-sm-4 col_sm_padding"
              >
                <h5 className="footer-text-head fw-bold">Follow us</h5>
                <ul className="list-unstyled social-links mt-2 mt-sm-4">
                  <li>
                    <img src={Instagram} alt="Instagram" />
                    <Link
                      className="footer-text ms-2"
                      to="https://www.instagram.com/simplerenovate"
                      target="_blank"
                    >
                      Instagram
                    </Link>
                  </li>
                  <li>
                    <img src={Facebook2} alt="Facebook2" />
                    <Link
                      className="footer-text ms-2"
                      to="https://www.facebook.com/profile.php?id=61577018560484"
                      target="_blank"
                    >
                      Facebook
                    </Link>
                  </li>
                  <li>
                    <img src={Linkedin} alt="Linkedin" />
                    <Link
                      className="footer-text ms-2"
                      to="https://www.linkedin.com/company/simplerenovate"
                      target="_blank"
                    >
                      LinkedIn
                    </Link>
                  </li>
                  <li>
                    <img src={Twitter} alt="Twitter" />
                    <Link
                      className="footer-text ms-2"
                      to="https://x.com/SimpleRenovate"
                      target="_blank"
                    >
                      X
                    </Link>
                  </li>
                  <li>
                    <img src={Youtube} alt="Youtube" />
                    <Link
                      className="footer-text ms-2"
                      to="https://www.youtube.com/@simplerenovate"
                      target="_blank"
                    >
                      YouTube
                    </Link>
                  </li>
                  {/* <li>
                    <img src={Youtube} alt="Youtube" />
                    <Link
                      className="footer-text ms-2"
                      to="https://www.tiktok.com/@simplerenovate?_t=ZT-90VJdZRcFcz&_r=1"
                    >
                      Tik Tok
                    </Link>
                  </li> */}
                </ul>
              </Col>

              <Col
                lg={3}
                md={4}
                sm={6}
                col={6}
                className="mt-3 col_sm_padding"
              ></Col>
            </Row>

            <Row className="footer-bottom mt-3 hero-width">
              <Col md={12} sm={12} className="col_sm_padding_footer">
                <div className="footer_img_link">
                  <div className="me-3 me-sm-5">
                    <img
                      src={SimpleRenovate}
                      alt="SimpleRenovate Logo"
                      className="footer-logo img-fluid"
                    />
                    <span className="d-block mt-2 ft-500 ft-15">
                      © 2026 SimpleRenovate.
                    </span>{" "}
                  </div>
                  <div className="flex_link_footer">
                    <Link
                      className="footer-text me-0 me-sm-5 mt-1 mt-sm-5"
                      to="/terms-of-services"
                      onClick={() => handleViewDetails()}
                    >
                      Terms of Service
                    </Link>
                    <Link
                      className="footer-text mt-0 mt-sm-5"
                      to="/privacy-policies"
                      onClick={() => handleViewDetails()}
                    >
                      Privacy Policy
                    </Link>
                  </div>
                </div>

                <div className="footer-apps ctm-download-link">
                  <p className="ft-500 ft-15">Download our Mobile App</p>
                  <Link
                    to="https://play.google.com/store/games?hl=en"
                    target="_blank"
                  >
                    <img
                      src={DownloadourMobileApp}
                      alt="Download App"
                      className="img-fluid"
                    />
                  </Link>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProfessionalFooter;
